module.exports = __webpack_public_path__ + "static/media/im-checkout@2x.3d8a49ca.svg";